import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { shouldPublishAuthoredMethodology } from './authoredNarrativeLoader';
import type { UrbanHeatIslandSummaryFacts } from './urbanHeatIslandNarrativeFacts';

const CHART_ID = 'urban_heat_island_map';

export function buildUrbanHeatIslandTokens(facts: UrbanHeatIslandSummaryFacts): Record<string, string> {
  const medianUhii =
    facts.medianUhiiDegHourDay != null ? facts.medianUhiiDegHourDay.toFixed(2) : '—';
  const minUhii = facts.minUhii != null ? facts.minUhii.toFixed(2) : '—';
  const maxUhii = facts.maxUhii != null ? facts.maxUhii.toFixed(2) : '—';
  const selectedValueSentence =
    facts.medianPercentile != null
      ? ` Median tract percentile rank was ${facts.medianPercentile.toFixed(1)} (percentile is relative rank, not degrees).`
      : '';

  return {
    locationName: facts.locationName,
    medianUhii,
    minUhii,
    maxUhii,
    selectedValueSentence,
    tractCount: String(facts.tractCount),
    sourceVintage: facts.sourceVintage,
  };
}

export function buildUrbanHeatIslandAuthoredBundle(facts: UrbanHeatIslandSummaryFacts) {
  const tokens = buildUrbanHeatIslandTokens(facts);
  const bundle = renderAuthoredNarrativeBundle(CHART_ID, 'default', tokens);
  if (!shouldPublishAuthoredMethodology(bundle.authoringStatus)) {
    bundle.methodology = undefined;
  }
  return bundle;
}

export function urbanHeatIslandOverviewDescription(fallback: string): string {
  return getAuthoredOverview(CHART_ID, 'default', fallback);
}
